import hexStringToArrayBuffer from './hexStringToArrayBuffer.js';
import getContentEncryptionIv from './getContentEncryptionIv.js';
import { base64ToArrayBuffer } from './base64ArrayBufferTranslator.js';

export default {
    async decryptText(encryptedBase64) {
        const encryptedArrayBuffer = base64ToArrayBuffer(encryptedBase64);

        const decryptedArrayBuffer = await this.decryptArrayBuffer(encryptedArrayBuffer);

        return new TextDecoder().decode(decryptedArrayBuffer);
    },
    async decryptArrayBuffer(encryptedArrayBuffer) {
        const contentEncryptionIv = await getContentEncryptionIv();

        const importedKey = await crypto.subtle.importKey(
            'raw',
            hexStringToArrayBuffer(import.meta.env.VITE_CONTENT_ENCRYPTION_PASSPHRASE),
            { name: 'AES-GCM', length: 256 },
            false,
            ['decrypt']
        );

        return await crypto.subtle.decrypt(
            {
                name: 'AES-GCM',
                iv: contentEncryptionIv,
            },
            importedKey,
            encryptedArrayBuffer
        );
    },
};
